import React from "react";
import Home from "./Pages/Home/Homescreen";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
